/* eslint-disable unicorn/numeric-separators-style -- these are the canonical FNV-1a constants, not arbitrary numbers */
const FNV_OFFSET_BASIS = 0x811c9dc5;
const FNV_PRIME = 0x01000193;
/* eslint-enable unicorn/numeric-separators-style */

/**
 * FNV-1a (32-bit). Deterministic, well-distributed, non-cryptographic hash — same
 * constants GrowthBook uses internally for experiment bucketing.
 */
export const fnv1a = (str: string): number => {
  let hash = FNV_OFFSET_BASIS;

  for (let i = 0; i < str.length; i++) {
    // eslint-disable-next-line unicorn/prefer-code-point -- FNV-1a hashes UTF-16 code units per spec; codePointAt would break the i++/length loop invariant on astral characters
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, FNV_PRIME);
  }

  return hash >>> 0;
};

export type ExperimentVariant = 'A' | 'B';

export const computeVariant = (
  testName: string,
  userId: string,
  country: null | string | undefined,
): ExperimentVariant => {
  const key = `${testName}:${userId.toLowerCase()}:${(country ?? 'UNKNOWN').toUpperCase()}`;

  return fnv1a(key) % 100 < 50 ? 'A' : 'B';
};
